import { render, staticRenderFns } from "./merchantBind.vue?vue&type=template&id=1597f4a7&scoped=true"
import script from "./merchantBind.vue?vue&type=script&lang=js"
export * from "./merchantBind.vue?vue&type=script&lang=js"
import style0 from "./merchantBind.vue?vue&type=style&index=0&id=1597f4a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597f4a7",
  null
  
)

export default component.exports